export enum DeviceType {
	IPad = 0,
	RaspberryPi = 10,
	AndroidTablet = 20,
	IPhone = 30,
	AndroidPhone = 40,
	WindowsLaptop = 50,
	Macbook = 60,
	Other = 9999
}